import { css } from '@emotion/react';
import { margins } from '@spotnana/blocks/src/utils';

export const footer_wrapper = css`
  flex: 1;
`;

export const company_policy_section = css`
  ${margins.yt.m1}
`;
